import React from 'react'
import { Box, Typography } from '@mui/material'
import GaugeComponent from 'react-gauge-component'
import { motion } from 'framer-motion'
import Banner from 'atoms/Banner'
import Card from 'atoms/Card'
import Gauge from 'atoms/Gauge'

const labelSets = {
  retirement: {
    heading: 'RETIREMENT READINESS SCORE',
    labels: [
      'Not On Track',
      'Good, with room for improvement!',
      'Right on track!',
    ],
    goalLabel: (goal) => `Based on your retirement goal of ${goal}`,
  },
  legacy: {
    heading: 'LEGACY PREPAREDNESS SCORE',
    labels: [
      'Legacy At Risk',
      'Progressing Well, Needs Attention',
      'Legacy Secured',
    ],
    goalLabel: (goal) => `Based on your legacy goal of ${goal}`,
  },
}

const getStatusLabel = (value, labels) => {
  if (value < 55) return labels[0]
  if (value < 75) return labels[1]
  return labels[2]
}

function ScoreCard({ value, goal, type = 'retirement', hyperOnboarding = false }) {
  const { heading, labels, goalLabel } = labelSets[type] || labelSets.retirement

  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
    >
      <Typography display="flex" align="left" variant="body2FunHeader" mb={2}>
        {heading}
      </Typography>

      <Card>
        <Box
          sx={{
            padding: '24px',
            display: 'flex',
            position: 'relative',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'left',
            color: '#262627',
          }}
        >
          {/* Gauge */}
          {hyperOnboarding ? <Gauge value={65} hyperOnboarding /> : <Gauge value={value} />}

          {/* Text */}
          <Box
            sx={{
              zIndex: 10,
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'left',
              gap: '8px',
              justifyContent: 'flex-start',
            }}
          >
            <Typography variant="statusLabel">
              {hyperOnboarding ? 'Unsure...' : getStatusLabel(value, labels)}
            </Typography>
            <Typography variant="body2" color="#495057">
              {goalLabel(goal)}
            </Typography>
          </Box>
        </Box>
      </Card>
    </motion.div>
  )
}

export default ScoreCard
